import React, { useState, useEffect } from "react";
import { Alert } from "react-bootstrap";

const NotificationStack = ({ notifications, removeNotification }) => {
    useEffect(() => {
        if (notifications.length > 0) {
            const timeout = setTimeout(() => {
                removeNotification();
            }, 3000); // Každé oznámení zmizí po 3 sekundách

            return () => clearTimeout(timeout);
        }
    }, [notifications, removeNotification]);

    return (
        <div className="notification-stack">
            {notifications.map((notification, index) => (
                <Alert key={index} variant="success" className="notification">
                    {notification}
                </Alert>
            ))}
        </div>
    );
};

export default NotificationStack;
